import { useListContext, Button, Toolbar, useDataProvider } from "react-admin";
import DownloadIcon from "@mui/icons-material/Download";
import { settings } from "app";
import { tenants } from "utils/tenants";

export const ExportXlsButton = ({ exporter, ...props }) => {
  const { data } = useListContext();
  const dataProvider = useDataProvider();

  if (settings.tenant === tenants.MGU) return null;

  const handleClick = async () => {
    if (!data || data.length === 0) {
      return;
    }

    await exporter(data, dataProvider);
  };

  return (
    <Toolbar
      {...props}
      sx={{
        background: "transparent",
        "&.RaToolbar-desktopToolbar": {
          minHeight: "auto",
        },
      }}
    >
      <Button
        color="primary"
        startIcon={<DownloadIcon />}
        label="Excel"
        onClick={handleClick}
      />
    </Toolbar>
  );
};
